import { FC } from 'react';
import { Input } from 'antd';
import type { InputProps } from 'antd/lib/input';
import styles from './index.module.scss';

const InputPasswordCore: FC<InputProps> = (props) => {
  return <Input.Password {...props} className={styles['input']} />;
};

export default InputPasswordCore;
